import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentUser: null,
  lodaing: false,
  error: false,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginStarted: (state) => {
      state.lodaing = true;
    },
    loginSuccess: (state, action) => {
      state.lodaing = false;
      state.currentUser = action.payload;
    },
    loginFailure: (state) => {
      state.lodaing = false;
      state.error = true;
    },

    logout: (state) => {
      state.currentUser = null;
      state.lodaing = false;
      state.error = false;
    },
  },
});

export const { loginStarted, loginSuccess, loginFailure, logout } =
  userSlice.actions;

export default userSlice.reducer;
